import React from "react";

export default function AddVideo() {
  return <div></div>;
}
